module.exports = __webpack_public_path__ + "img/process-img-1.1b9416f9.png";